module.exports = __webpack_public_path__ + "img/2.9a1b6b30.png";